module.exports = __webpack_public_path__ + "static/media/04_twitter_image.10cd8ed8.jpg";